import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { fmtDateTime } from "../lib/format";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Trash2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { toast } from "sonner";

const ACTION_COLOR = {
  login: "bg-blue-100 text-blue-700", logout: "bg-slate-100 text-slate-600",
  create: "bg-emerald-100 text-emerald-700", update: "bg-amber-100 text-amber-700",
  delete: "bg-rose-100 text-rose-700", mutation: "bg-indigo-100 text-indigo-700",
};

export default function AuditLog() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => api.get("/audit-logs").then((r) => setLogs(r.data));
  useEffect(() => { load(); }, []);
  const filtered = logs.filter((l) => !filter || (l.username || "").toLowerCase().includes(filter.toLowerCase()) || (l.entity || "").toLowerCase().includes(filter.toLowerCase()) || (l.detail || "").toLowerCase().includes(filter.toLowerCase()));

  const clearAll = async () => {
    if (!window.confirm("Hapus SEMUA data log audit secara permanen? Tindakan ini tidak dapat dibatalkan.")) return;
    try { const { data } = await api.delete("/audit-logs"); toast.success(`${data.deleted} log dihapus`); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold font-display text-slate-900">Log Audit</h1>
          {user.role === "master" && <p className="text-sm text-slate-500">Pencatatan otomatis setiap aksi pengguna (aktivitas Master tidak dicatat)</p>}
        </div>
        {user.role === "master" && (
          <Button variant="outline" onClick={clearAll} className="border-rose-300 text-rose-700 hover:bg-rose-50" data-testid="clear-audit-logs-button">
            <Trash2 className="h-4 w-4 mr-1.5" /> Hapus Semua Log
          </Button>
        )}
      </div>
      <Input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter user / entitas / detail..." className="max-w-sm" />
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>Waktu</TableHead><TableHead>User</TableHead><TableHead>Peran</TableHead><TableHead>Aksi</TableHead><TableHead>Entitas</TableHead><TableHead>Detail</TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs text-slate-500">{fmtDateTime(l.timestamp)}</TableCell>
                <TableCell className="font-mono text-xs">{l.username}</TableCell>
                <TableCell className="text-xs">{l.role}</TableCell>
                <TableCell><Badge className={`${ACTION_COLOR[l.action] || "bg-slate-100 text-slate-600"} hover:${ACTION_COLOR[l.action] || ""}`}>{l.action}</Badge></TableCell>
                <TableCell className="text-xs">{l.entity}</TableCell>
                <TableCell className="text-xs text-slate-500">{l.detail}</TableCell>
              </TableRow>
            ))}
            {filtered.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-8">Belum ada log</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
